import { render } from "./ContactsLayer.vue?vue&type=template&id=0023bcef"
import script from "./ContactsLayer.vue?vue&type=script&lang=js"
export * from "./ContactsLayer.vue?vue&type=script&lang=js"

import "./ContactsLayer.vue?vue&type=style&index=0&id=0023bcef&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__